/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */

import * as actions from '../actions/actionTypes';

export const initialState = {
  formTemplate: undefined,
  formTemplateVersion: {
    fields: [],
    title: '',
    description: '',
  },
  activeAccordion: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.SET_FORM_TEMPLATE:
      return {
        ...state,
        formTemplate: action.value,
      };
    case actions.SET_FORM_TEMPLATE_VERSION:
      return {
        ...state,
        formTemplateVersion: action.value,
      };
    case actions.ADD_A_NEW_FIELD: {
      const templateToAdd = { ...state.formTemplateVersion };
      const newField = { ...action.value };
      const previousFieldPosition = templateToAdd.fields[templateToAdd.fields.length - 1].position;

      newField.position = previousFieldPosition + 1;
      templateToAdd.fields.push(newField);

      return { ...state, formTemplateVersion: templateToAdd };
    }
    case actions.SET_FIELD_VALUE: {
      const { position, fieldName, fieldValue } = action.payload;
      const formTemplateCopy = { ...state.formTemplateVersion };
      const field = formTemplateCopy.fields.find((f) => {
        return f.position === position;
      });

      Object.keys(field).map(function (key) {
        if (key === fieldName) {
          return (field[fieldName] = fieldValue);
        }
      });

      Object.keys(field.validations).map(function (key) {
        if (key === fieldName) {
          field.validations[key] = fieldValue;
        }
      });

      return { ...state, formTemplateVersion: formTemplateCopy };
    }

    case actions.SET_FIELD_OTHER_ENABLED: {
      const { position, otherValue } = action.payload;
      const formTemplateCopy = { ...state.formTemplateVersion };
      const field = formTemplateCopy.fields.find((f) => {
        return f.position === position;
      });
      field.other_enabled = otherValue;

      return { ...state, formTemplateVersion: formTemplateCopy };
    }

    case actions.SET_OTHER_FIELD_LABEL: {
      const { position, otherFieldLabel } = action.payload;
      const formTemplateCopy = { ...state.formTemplateVersion };
      const field = formTemplateCopy.fields.find((f) => {
        return f.position === position;
      });
      field.other_field = otherFieldLabel;

      return { ...state, formTemplateVersion: formTemplateCopy };
    }

    case actions.RESET_FIELD: {
      const { resetPosition, resetFieldName } = action.payload;
      const resetFormTemplateCopy = { ...state.formTemplateVersion };
      const resetField = resetFormTemplateCopy.fields.find((f) => {
        return f.position === resetPosition;
      });

      const optionFieldTypes = ['checkbox', 'radio', 'dropdown'];
      if (!optionFieldTypes.includes(resetFieldName)) resetField.options = [];

      switch (resetFieldName) {
        case 'single_line': {
          resetField.validations = {
            required: false,
            character_restriction: null,
            character_limit: null,
            input_format: null,
          };

          break;
        }
        case 'date': {
          resetField.validations = {
            required: false,
            date_restriction: '',
          };

          break;
        }
        default: {
          resetField.validations = {
            required: false,
          };

          break;
        }
      }

      return { ...state, formTemplateVersion: resetFormTemplateCopy };
    }

    case actions.SET_ACTIVE_ACCORDION: {
      if (Array.isArray(action.value)) {
        return {
          ...state,
          activeAccordion: [...state.activeAccordion, ...action.value],
        };
      }
      return {
        ...state,
        activeAccordion: [action.value],
      };
    }

    case actions.SET_INACTIVE_ACCORDION: {
      const activeAccordionCopy = [...state.activeAccordion];

      if (Array.isArray(action.value)) {
        return { ...state, activeAccordion: action.value };
      }
      const excludeInactiveAccordion = activeAccordionCopy.filter((accordionIndex) => accordionIndex !== action.value);

      return { ...state, activeAccordion: excludeInactiveAccordion };
    }

    case actions.SET_REARRANGE_POSITION: {
      const rearrangeTemplateCopy = { ...state.formTemplateVersion };
      const { rearrangeFields, draggedItem, drugOverIndex } = action.payload;

      const rearrangeFieldSets = rearrangeFields.filter((item) => item !== draggedItem);

      rearrangeFieldSets.splice(drugOverIndex, 0, draggedItem);

      const recalculatePosition = rearrangeFieldSets.map((item, index) => {
        item.position = index + 1;
        return item;
      });

      const rearrangeNewfields = {
        ...rearrangeTemplateCopy,
        fields: recalculatePosition,
      };

      return { ...state, formTemplateVersion: rearrangeNewfields };
    }
    case actions.SET_TEMPLATE_VALUE: {
      const { templateAttributeId, templateValue } = action.payload;
      const formTemplateCopy = {
        ...state.formTemplateVersion,
        [templateAttributeId]: templateValue,
      };

      return { ...state, formTemplateVersion: formTemplateCopy };
    }
    case actions.REMOVE_FIELD: {
      const { id } = action.payload;
      const removeFieldTemplateCopy = { ...state.formTemplateVersion };
      const reducedFields = removeFieldTemplateCopy.fields.filter((field) => field.id !== id);

      const reducedFieldsWithNewPositions = reducedFields.map((item, index) => {
        item.position = index + 1;
        return item;
      });

      const templateWithUpdatedFieldPositions = {
        ...removeFieldTemplateCopy,
        fields: reducedFieldsWithNewPositions,
      };

      const removeFieldFromActiveAccordian = state.activeAccordion.filter((value) => value !== id);

      return {
        ...state,
        formTemplateVersion: templateWithUpdatedFieldPositions,
        activeAccordion: removeFieldFromActiveAccordian,
      };
    }
    default:
      return state;
  }
}
